module.exports = __webpack_public_path__ + "media/9.af1833cd.wav";